import React, { useEffect, memo, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { SystemOverview } from './components/SystemOverview';
import { Bonuses } from './components/Bonuses';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingTable } from './components/PricingTable';
import { Accelerator } from './components/Accelerator';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostSection } from './components/CostSection';
import { Footer } from './components/Footer';
import { BottomPricing } from './components/BottomPricing';
export function App() {
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '980793120943222');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=980793120943222&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  const testimonials1 = [{
    initials: 'CR',
    name: 'Carlos R.',
    location: 'Buenos Aires | Empresario, 58 años',
    text: 'Pensé que era cosa de la edad. Empecé el Protocolo y en 30 días noté la diferencia. Tomo decisiones más rápido, recuerdo nombres en reuniones y llego al mediodía con la cabeza despejada. Algo que no me pasaba hace años.'
  }, {
    initials: 'JM',
    name: 'Jorge M.',
    location: 'Rosario | Contador independiente, 54 años',
    text: 'Los ejercicios son directos y sin vueltas. No es un jueguito de colores para jubilados. Es entrenamiento serio para hombres que todavía tienen mucho por delante y no se quieren quedar atrás.'
  }, {
    initials: 'RA',
    name: 'Roberto A.',
    location: 'Córdoba | Dueño de empresa, 61 años',
    text: 'El Tomo 2 de Memoria me cambió la práctica. En reuniones con clientes recuerdo datos, nombres y cifras sin anotar nada. La imagen que proyecto cambió completamente. Y el Método Blindaje es el complemento que no sabía que necesitaba.'
  }];
  const testimonials2 = [{
    initials: 'CR',
    name: 'Carlos R.',
    location: 'Buenos Aires | Empresario, 58 años',
    text: 'Compré un domingo a la noche. El lunes ya tenía el primer tomo impreso y empecé el entrenamiento. En 30 días de constancia noté diferencias concretas: velocidad en reuniones, nombres que antes se me escapaban, decisiones que antes me costaban el doble de tiempo. El Protocolo es serio, directo y sin vueltas. Exactamente lo que necesitaba.'
  }, {
    initials: 'JM',
    name: 'Jorge M.',
    location: 'Rosario | Contador independiente, 54 años',
    text: "Lo que más me sorprendió fue el Tomo 2. Yo pensaba que mi memoria era 'mala por naturaleza'. No era eso. Era que nunca la había entrenado con un sistema. Las técnicas del Palacio de la Memoria cambiaron completamente cómo retengo información en reuniones con clientes."
  }, {
    initials: 'RA',
    name: 'Roberto A.',
    location: 'Córdoba | Dueño de empresa, 61 años',
    text: 'El Bono 3 de Desafíos de Operaciones fue el que más impacto tuvo en mi vida cotidiana. Empecé a calcular mentalmente, a moverme sin GPS, a prestar atención en conversaciones de verdad. Mi familia notó el cambio antes que yo.'
  }, {
    initials: 'PM',
    name: 'Pablo M.',
    location: 'Tucumán | Médico, 57 años',
    text: 'Agregué el Método Blindaje y fue el complemento perfecto. El Protocolo de Vacío lo uso en situaciones de tensión con pacientes y familias. El Filtro de Neutralidad cambió cómo proceso las noticias difíciles antes de comunicarlas. Es una herramienta que cualquier hombre de mi edad debería tener.'
  }];
  return <div className="min-h-screen bg-dark text-white selection:bg-brand selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProof data-id="element-2" />
      <Testimonials testimonials={testimonials1} data-id="element-3" />
      <PainPoints data-id="element-4" />
      <SystemOverview data-id="element-5" />
      <Bonuses data-id="element-6" />

      <section className="py-12 px-4 text-center bg-dark-card border-y border-dark-border" data-id="element-7">
        <div className="max-w-3xl mx-auto" data-id="element-8">
          <div className="text-brand font-bold mb-4 tracking-widest text-sm" data-id="element-9">
            ⏰ PRECIO DE LANZAMIENTO CIERRA EN:
          </div>
          <CountdownTimer data-id="element-10" />
          <div className="mt-4 flex items-center justify-center space-x-2" data-id="element-11">
            <div className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-12" />
            <span className="text-sm text-gray-400" data-id="element-13">
              Quedan pocos cupos al precio de lanzamiento
            </span>
          </div>
          <div className="w-full max-w-md mx-auto h-2 bg-dark rounded-full mt-4 overflow-hidden" data-id="element-14">
            <div className="h-full bg-brand w-[71%]" data-id="element-15" />
          </div>
          <div className="text-xs text-gray-500 mt-2" data-id="element-16">
            71% de los cupos ya tomados
          </div>
        </div>
      </section>

      <PricingTable data-id="element-17" />
      <Accelerator data-id="element-18" />

      <div className="py-12 pt-[15px] pb-[15px]" data-id="element-19">
        <div className="text-center mb-8" data-id="element-20">
          <h2 className="text-3xl font-black ml-[20px] mr-[20px]" data-id="element-21">
            ⭐ LO QUE DICEN LOS HOMBRES QUE YA LO USAN
          </h2>
          <p className="text-gray-400 mt-2 ml-[20px] mr-[20px]" data-id="element-22">
            +500 hombres de todo el país ya entrenan con el Protocolo
          </p>
        </div>
        <Testimonials testimonials={testimonials2} data-id="element-23" />
      </div>

      <Guarantee data-id="element-24" />
      <FAQ data-id="element-25" />
      <CostSection data-id="element-26" />

      <BottomPricing data-id="element-27" />

      <Footer data-id="element-28" />
    </div>;
}